export default "__VITE_ASSET__SDq3fbqF__"